export default "dist/images/components-columns-width-control-3-3.8b9a3da.png";